import { fetchEndpoint } from '../server/network';

// 获取网关地址
export const accessDns =
() =>
fetchEndpoint(
  '/v2/ecapi.access.dns',
  'POST',
  {
  }
)


//判断是否关注公众号接口
export const authSubscribe =
() =>
fetchEndpoint(
  '/v2/ecapi.auth.subscribe',
  'GET',
  {}
)



// 销售商cidC
export const getCid =
() =>
fetchEndpoint(
  '/v2/ecapi.get.cid',
  'GET',
  {
  }
)



// 批量调用接口
export const accessBatch =
(batch) =>
fetchEndpoint(
  '/v2/ecapi.access.batch',
  'POST',
  {
    "batch": batch, 
  }
)




// WEBPACK FOOTER //
// ./src/api/access.js